import { useParams } from 'react-router-dom'

import {
    IEntity,
    INLUDataExample,
    useNLUDataStore,
} from '../../../stores/nluDataStore'

import EntitySection from './EntitySection/EntitySection'
import IntentSection from './IntentSection/IntentSection'

import styles from './nlu-data-example.module.scss'

export interface INLUDataExampleProps {
    example: INLUDataExample
    isAnyEntityEditing: boolean
    setIsAnyEntityEditing: React.Dispatch<React.SetStateAction<boolean>>
    examplesRef: React.RefObject<HTMLDivElement>
}

function NLUDataExample(props: INLUDataExampleProps) {
    const { example, isAnyEntityEditing, setIsAnyEntityEditing, examplesRef } =
        props

    const { tab } = useParams()

    const [{ entities: allEntities }, { deleteExample, editExampleEntity }] =
        useNLUDataStore()

    return (
        <div className={styles.nluDataExample}>
            <EntitySection
                example={example}
                isAnyEntityEditing={isAnyEntityEditing}
                setIsAnyEntityEditing={setIsAnyEntityEditing}
                examplesRef={examplesRef}
                allEntities={allEntities}
                deleteExample={deleteExample}
                setEntities={(entities: IEntity[]) =>
                    tab && editExampleEntity(tab, example._id, entities)
                }
            />
            <IntentSection example={example} examplesRef={examplesRef} />
        </div>
    )
}

export default NLUDataExample
